/**
 * Accreditation Logos Component - Brutalist Streetwear Edition
 *
 * Displays accreditation logos in brutalist card layout
 * with heavy borders and geometric hover effects.
 */

import { LazyImage } from '../LazyImage';

interface Logo {
  name: string;
  src: string;
  alt: string;
}

interface AccreditationLogosProps {
  logos: Logo[];
}

export const AccreditationLogos: React.FC<AccreditationLogosProps> = ({ logos }) => {
  if (!logos || logos.length === 0) {
    return null;
  }

  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="container mx-auto px-6">
        <h2 className="font-display text-4xl md:text-5xl font-bold uppercase tracking-wider text-center mb-12 text-rich_black-500">
          Accredited By
        </h2>

        {/* Logos Grid: Clean display without borders */}
        <div className="flex flex-wrap items-center justify-center gap-8">
          {logos.map((logo) => (
            <LazyImage
              key={logo.name}
              src={logo.src}
              alt={logo.alt}
              className="h-32 md:h-40 w-auto object-contain"
            />
          ))}
        </div>
      </div>
    </section>
  );
};
